import React, { useState, useEffect } from "react";
import { Card, Row, Col, Table } from "antd";
// import {uid} from 'react-uid';
import { IDebtService, DebtService } from "../../services/debt-service";
import { loadAppConfig } from "../../../../config/app-config";
import { useId24 } from "../../../../drivers/id24/Id24-provider";
const appConfig = loadAppConfig();

export interface Props {
  baseURL: string;
  caption: string;
  accountNo: string;
  loading: boolean;
  type: string;
  cifId: string;
  debtContact: any;
}

export const TableByBank: React.FC<Props> = ({
  caption,
  accountNo,
  baseURL,
  loading,
  type,
  cifId,
  debtContact,
}): React.ReactElement => {
  const debtService = DebtService;
  const { tokenAccess, login, logout, id24Axios } = useId24();
  const apiBaseUrl = id24Axios(appConfig.apiBaseUrl);
  const apiBaseUrlDebt = id24Axios(appConfig.apiBaseUrlDebt);

  const [resData, setResData] = useState([]);

  useEffect(() => {
    // console.log(cifId)
    getDataTable(cifId, accountNo);
  }, [cifId, accountNo]);

  const getDataTable = async (cif: string, accountNo: string): Promise<any> => {
    // console.log(cifId)
    const result = (await debtService(apiBaseUrlDebt).getDebtContactBank(
      cifId,
      accountNo
    )) as any;
    // console.log(result)
    const data = (await result.result.map(
      (
        x: {
          accountNo: string;
          custCif: string;
          id_card: string;
          status: string;
          work: string;
          add1: string;
          add2: string;
          add3: string;
          add4: string;
          dist: string;
          state: string;
          chn: string;
          zipcode: string;
          city: string;
        },
        index: number
      ) => {
        let chnTxt = "";
        if (x.chn === "HOME") {
          chnTxt = "ทะเบียนบ้าน";
        } else if (x.chn === "NOW") {
          chnTxt = "ปัจจุบัน";
        } else if (x.chn === "ACC") {
          chnTxt = "สินเชื่อ";
        } else if (x.chn === "CARD") {
          chnTxt = "บัตรเครดิต";
        } else {
          chnTxt = "ไม่ระบุ";
        }
        const mapData = {
          key: index,
          custName: debtContact.custName + " " + debtContact.custLastName,
          custLastName: debtContact.custLastName,
          idCard: debtContact.idCard,
          custStatus: debtContact.status,
          work: debtContact.work,
          homePhone: debtContact.phone,
          officePhone: debtContact.officePhone,
          mobile: debtContact.mobile,
          addNumber: x.add1 + " " + x.add2 + " " + x.add3 + " " + x.add4,
          addSubDistrict: x.dist,
          addDistrict: x.city,
          addProvince: x.state,
          zipcode: x.zipcode,
          accountNo: x.accountNo,
          chn: chnTxt,
        };
        return mapData;
      }
    )) as any;
    setResData(data);
  };

  const columns = [
    {
      title: "ชื่อ-สกุล",
      dataIndex: "custName",
      key: "custName",
      width: 200,
    },
    {
      title: "เลขบัตรประชาชน",
      dataIndex: "idCard",
      key: "idCard",
      width: 100,
    },
    {
      title: "ที่อยู่อ้างอิง",
      dataIndex: "chn",
      key: "chn",
      width: 100,
    },
    {
      title: "อาชีพ",
      dataIndex: "work",
      key: "work",
      width: 200,
    },
    {
      title: "เบอร์โทรศัพท์บ้าน",
      dataIndex: "homePhone",
      key: "homePhone",
      width: 140,
    },
    {
      title: "เบอร์โทรศัพท์ที่ทำงาน",
      dataIndex: "officePhone",
      key: "officePhone",
      width: 150,
    },
    {
      title: "เบอร์มือถือ",
      dataIndex: "mobile",
      key: "mobile",
      width: 100,
    },
    {
      title: "บ้านเลขที่",
      dataIndex: "addNumber",
      key: "addNumber",
      width: 150,
    },
    {
      title: "ตำบล / แขวง ",
      dataIndex: "addSubDistrict",
      key: "addSubDistrict",
      width: 150,
    },
    {
      title: "อำเภอ / เขต ",
      dataIndex: "addDistrict",
      key: "addDistrict",
      width: 150,
    },
    {
      title: "จังหวัด",
      dataIndex: "addProvince",
      key: "addProvince",
      width: 150,
    },
    {
      title: "รหัสไปรษณีย์",
      dataIndex: "zipcode",
      key: "zipcode",
      width: 150,
    },
  ];

  return (
    <>
      <Table
        dataSource={resData}
        columns={columns}
        scroll={{ x: "calc(1500px + 50%)" }}
        // rowKey={(record:any) => record.id}
      />
    </>
  );
};
